import { createSlice } from '@reduxjs/toolkit';
import { STATUS_LOADING } from 'common/constants';

import { IState, STATE } from '../types/state';

import setSavedFiltersStatusLoading from './setSavedFiltersStatusLoading';
import setSavedFilters from './setSavedFilters';
import setSavedFilter from './setSavedFilter';

import addNewSavedFilter from './addNewSavedFilter';
import removeSavedFilter from './removeSavedFilter';
import setSavedFilterStatusLoading from './setSavedFilterStatusLoading';
import setDeletingFilterStatusLoading from './setDeletingFilterStatusLoading';
import setSavingFilterStatusLoading from './setSavingFilterStatusLoading';
import setActiveFilterId from './setActiveFilterId';
import setGettingFilterStatusLoading from './setGettingFilterStatusLoading';
import setUpdatingFilterId from './setUpdatingFilterId';
import setNormalizedFilterData from './setNormalizedFilterData';

const initialState: IState = {
  savedFilters: {
    statusLoading: STATUS_LOADING.load,
    data: {},
  },
  deletingFilter: {
    statusLoading: STATUS_LOADING.done,
  },
  savingFilter: {
    statusLoading: STATUS_LOADING.done,
  },
  gettingFilter: {
    statusLoading: STATUS_LOADING.done,
  },
  activeFilter: {
    id: 0,
  },
  updatingFilter: {
    id: 0,
  },
};

const slice = createSlice({
  name: STATE,
  initialState,
  reducers: {
    setSavedFilters,
    setSavedFiltersStatusLoading,
    setSavedFilterStatusLoading,
    setSavedFilter,
    addNewSavedFilter,
    removeSavedFilter,
    setDeletingFilterStatusLoading,
    setSavingFilterStatusLoading,
    setActiveFilterId,
    setGettingFilterStatusLoading,
    setUpdatingFilterId,
    setNormalizedFilterData,
  },
});

export default slice;
